import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";

export type AppLocale = "en" | "fr";

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

/** Loads French strings on demand so the entry chunk only ships English by default. */
export async function ensureLocaleLoaded(locale: AppLocale): Promise<void> {
  if (locale === "en") {
    return;
  }
  if (!i18n.hasResourceBundle("fr", "translation")) {
    const { default: fr } = await import("./locales/fr.json");
    i18n.addResourceBundle("fr", "translation", fr);
  }
}

/** Switches UI language, fetching non-English bundles when needed. */
export async function changeAppLocale(locale: AppLocale): Promise<void> {
  await ensureLocaleLoaded(locale);
  await i18n.changeLanguage(locale);
}

export default i18n;
